import { ContainerBoxInterface } from '@peakconcepts/landingpage-kit'

const itemTitleConfig = {
  defaultCss: {
    textAlign: 'left'
  },
  margin: {
    desktop: '50px 0 10px',
    tablet: '50px 0 10px',
    mobile: '30px 0 10px'
  }
}

const itemDescriptionConfig = {
  defaultCss: {
    textAlign: 'left'
  }
}

const data: ContainerBoxInterface = {
  containers: [
    {
      classNames: 'container',
      padding: {
        fullHd: '40px 0',
        widescreen: '40px 0',
        desktop: '80px 40px',
        tablet: '60px 40px',
        mobile: '40px 20px'
      },
      containers: [
        {
          classNames: 'columns is-multiline',
          containers: [
            {
              classNames: 'column is-full',
              containers: [
                {
                  type: 'text',

                  config: {
                    size: 1,
                    defaultCss: {
                      textAlign: 'left'
                    },
                    text: 'Impressum'
                  }
                },
                {
                  type: 'text',

                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Peakconcepts GmbH<br/>Anton-Huber-Straße 20<br/>73430 Aalen<br/><br/>E-Mail: info@leeeds.de<br/>Telefon: 07361 / 99 78 500<br/><br/>Handelsregister: Amtsgericht Ulm, HRB 734304<br/>Geschäftsführer: Melik Su<br/>USt-IdNr: DE309273813'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'Bildnachweise'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      '© Rawpixel.com // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/business-team-corporate-marketing-working-concept-337921478">Shutterstock</a><br/>© Rawpixel.com // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/business-coworking-laptop-finance-partnership-concept-381680755">Shutterstock</a><br/>© Roman Samborskyi // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/smiling-happy-businessman-glasses-white-shirt-618974327">Shutterstock</a><br/>© Gorodenkoff // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/financier-works-on-personal-computer-showing-1013842081">Shutterstock</a><br/>© pong-photo9 // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/businessman-showing-business-growth-on-chart-1417150349">Shutterstock</a><br/>© stokkete // <a target="_blank" rel="noopener noreferrer" href="https://www.crushpixel.com/stock-photo/cheerful-businessman-with-thumbs-up-618539.html">Crushpixel</a><br/>© stokkete // <a target="_blank" rel="noopener noreferrer" href="https://www.crushpixel.com/stock-photo/stressful-job-618593.html">Crushpixel</a><br/>© stokkete // <a target="_blank" rel="noopener noreferrer" href="https://www.crushpixel.com/stock-photo/stressful-job-618597.html">Crushpixel</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/portrait-cheerful-young-manager-handshake-new-1312231271">Shutterstock</a><br/>© NDAB Creativity // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/portrait-businessman-working-talking-on-mobile-1806174631">Shutterstock</a><br/>© NDAB Creativity // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/happy-businessman-dressed-suit-modern-office-551937682">Shutterstock</a><br/>© Pressmaster // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/confident-businessmen-sitting-by-table-during-309942056">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/serious-businessman-looking-laptop-office-holding-1204574623">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/young-businessman-working-laptop-modern-office-1066084298">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/attractive-businessman-looking-mobile-phone-while-1013053924">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/portrait-young-man-sitting-his-desk-648506098">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/portrait-happy-smiling-businessman-eyeglasses-using-651564529">Shutterstock</a><br/>© Branislav Nenin // <a target="_blank" rel="noopener noreferrer" href="https://www.shutterstock.com/de/image-photo/handsome-businessman-eyeglasses-using-computer-talking-659604544">Shutterstock</a><br/>'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'EU-Streitschlichtung'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.<br/>Unsere E-Mail-Adresse finden Sie oben im Impressum.'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text:
                      'Verbraucher­streit­beilegung/Universal­schlichtungs­stelle'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'Haftung für Inhalte'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'Haftung für Links'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'Urheberrecht'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.'
                  }
                },
                {
                  type: 'text',

                  config: {
                    size: 4,
                    ...itemTitleConfig,
                    text: 'Rechtswirksamkeit dieses Haftungsausschlusses'
                  }
                },
                {
                  type: 'text',
                  config: {
                    ...itemDescriptionConfig,
                    text:
                      'Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in Ihrem Inhalt und Ihrer Gültigkeit davon unberührt.'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default data
